<div class="row">
    <div *ngFor="let column of columns" [ngClass]="column.class ? column.class : 'col'"
        class="align-items-center d-flex">
        <p-checkbox *ngIf="column.type === 'assign'" [formControl]="form.get(column.field)" binary="true"></p-checkbox>
        <mapfre-auditlib-input *ngIf="column.type === 'input'" [form]="form.get(column.field)"
            [readonly]="column?.options?.readonly"></mapfre-auditlib-input>
        <mapfre-auditlib-input *ngIf="column.type === 'number'" [form]="form.get(column.field)"
            [readonly]="column?.options?.readonly" type="number"></mapfre-auditlib-input>
        <mapfre-auditlib-circle *ngIf="column.type === 'name'" [name]="getName(form.get(column.field).value)"
            [title]="true">
        </mapfre-auditlib-circle>
        <mapfre-auditlib-calendar *ngIf="column.type === 'date' && !column.options?.readonly === true"
            [inline]="column.options.inline" [selectionMode]="column.options.selectionMode"
            [form]="form.get(column.field)" [minDate]="column.options.minDate" [maxDate]="column.options.maxDate">
        </mapfre-auditlib-calendar>
        <div *ngIf="column.type === 'date' && column.options.readonly === true">
            {{getDate(form.get(column.field).value) | dateFormat:false:false  | async}}
        </div>
        <mapfre-auditlib-select *ngIf="column.type === 'select'" [placeholder]="column.options.label"
            (change)="onSelectChange($event,column.field)" [form]="form.get(column.field)" [data]="column.options.data"
            [readonly]="column.options.readonly" [field]="column.options.field"
            [selectionMode]="column.options.selectionMode">
        </mapfre-auditlib-select>
        <div *ngIf="column.type === 'boolean'" class="state"
            (click)="form.get(column.field).setValue(!form.get(column.field).value)"
            [ngClass]="form.get(column.field).value ? 'state-active':'state-inactive'">
            <div class="align-items-center d-flex">
                <i class="icon icon-24-px-tick-doble"></i>
                {{column.options.text}}
            </div>
        </div>
    </div>
    <div class="align-items-center d-flex" [ngClass]="defaultActions.class ? defaultActions.class : 'col-2'">
        <button class="no-styles" (click)="onCancelledClicked()">
            <i class="icon icon-24-px-menu-cerrar"></i>
        </button>
        <button (click)="onSave(form)" class="no-styles">
            <i class="icon icon-24-px-guardar"></i>
        </button>
    </div>
</div>